// @flow
import React from 'react';
import { Form, FormikProps, Formik, FormikHelpers, FormikValues } from 'formik';
import * as Yup from 'yup';
import cogoToast from 'cogo-toast';
import api from 'apiClient/api';
import { CURRENT_COUNTRY_CODE } from 'config/env';
import { StringUtil } from 'utils/StringUtil';
import { FormButton } from 'components/molecules/formButton';
import { FormDropdown } from 'components/molecules/formDropdown';
import { FormInput } from 'components/molecules/formInput';
import { FormTextArea } from 'components/molecules/formTextArea';
import type { DropdownOption } from 'components/molecules/formDropdown';
import type { Contact, Vertical } from 'types/common';
// eslint-disable-next-line
import styles from "./styles.scss";
import { getGclid } from 'utils/GetGclid';

// const API_ENDPOINT = 'sendEmail.json';
const API_ENDPOINT = 'postLead'; // For  Sales force API

type Props = {
  verticals: Array<Vertical>,
  verticalId: number | null,
  isMobile: boolean,
  showVerticalDropdown?: boolean,
  contactEmail?: string,
  callPostLeadAPI?: boolean,
  origin?: string,
  utmParameters: {
    UTMSource: string,
    UTMMedium: string,
    UTMCampaign: string,
    UTMDisplay: string,
    UTMTerm: string,
    UTMContent: string,
    CampaignCode: string,
    ProjectInterested: string,
  },
};

type FormState = {
  subject?: string,
  firstname?: string,
  lastname?: string,
  contactUs_gclid_field?: string,
  emailaddress?: string,
  mobilenumber?: string,
  remarks?: string,
  country?: string,
  DialingCode?: string,
  interestedIn?: string,
};

type State = {
  data: FormState,
};

const initialState: State = {
  data: {
    subject: '',
    firstname: '',
    lastname: '',
    contactUs_gclid_field: '',
    emailaddress: '',
    mobilenumber: '',
    remarks: '',
    country: CURRENT_COUNTRY_CODE,
    DialingCode: CURRENT_COUNTRY_CODE,
    interestedIn: '',
  },
};

export class ContactUsForm extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      ...this.getInitialState(),
      selectedCountryName: 'IND',
      isSubmitted: false,
    };
  }

  getInitialState = () => {
    return {
      data: {
        ...initialState.data,
        subject: this.props.verticalId ? this.props.verticalId : -1,
      },
    };
  };

  getSubjectOptions = (): Array<DropdownOption> => {
    const { verticals } = this.props;

    return verticals.map((item: Vertical) => {
      return {
        value: item.id,
        label: item.sanitizedName,
      };
    });
  };

  render = () => {
    const { verticalId, isMobile, showVerticalDropdown = true } = this.props;
    const options = this.getSubjectOptions();
    const buttonMode = isMobile ? 'transparent' : 'light';
    const country_code = [
      { value: '+91', label: 'IND' },
      { value: '+1', label: 'U.S' },
      { value: '+968', label: 'OM' },
      { value: '+65', label: 'SG' },
      { value: '+44', label: 'U.K' },
      { value: '+61', label: 'AUS' },
      { value: ' ', label: 'OTHERS' },
    ];
    const interested_options = [
      {
        label: "I'm an interested homebuyer",
        value: "I'm an interested homebuyer",
      },
      {
        label: "I'm a real estate agent",
        value: "I'm a real estate agent",
      },
      {
        label: "I'm a vendor or partner",
        value: "I'm a vendor or partner",
      },
      {
        label: 'Other (please specify in the message section)',
        value: 'Other',
      },
    ];

    return (
      <div className={'form-container'}>
        <Formik
          initialValues={this.state.data}
          onSubmit={this.onSubmit}
          validationSchema={this.getSchema()}
        >
          {(props: FormikProps<State>) => (
            <Form>
              {!verticalId && showVerticalDropdown && (
                <FormDropdown
                  name={'subject'}
                  label={'How can we help?'}
                  options={options}
                  value={props.values['subject']}
                  showPlaceholder={false}
                />
              )}
              {/*{!isMobile && (*/}
              <FormInput
                name={'firstname'}
                label={'First Name'}
                placeholder={'First Name'}
                type={'text'}
                value={props.values['firstname']}
              />
              {/*)}*/}
              <FormInput
                name={'lastname'}
                label={'Last Name'}
                placeholder={'Last Name'}
                type={'text'}
                value={props.values['lastname']}
              />
               <FormInput
                id={'contactUs_gclid_field'}
                name={'contactUs_gclid_field'}
                type={'hidden'}
                value={props.values['contactUs_gclid_field']}
              />
              <FormInput
                name={'emailaddress'}
                label={'Email Address'}
                placeholder={'Email Address'}
                type={'email'}
                value={props.values['emailaddress']}
              />
              <div className={'contact-number-container'}>
                <FormDropdown
                  name={'country'}
                  label={'Country'}
                  placeholder={''}
                  options={country_code}
                  value={props.values['country']}
                  selected_country={e =>
                    this.setState({ selectedCountryName: e })
                  }
                  onDropDownChange={e => (
                    (props.values['DialingCode'] = e.value),
                    (props.values['mobilenumber'] =
                      initialState.data.mobilenumber)
                  )}
                  showPlaceholder={true}
                />
                <FormInput
                  name={'DialingCode'}
                  label={''}
                  placeholder={'CODE'}
                  type={'text'}
                  disabled={props.values['country'] !== ' '}
                  value={
                    props.values['country'] !== ' '
                      ? props.values['country']
                      : props.values['DialingCode']
                  }
                />
                <FormInput
                  name={'mobilenumber'}
                  label={'Mobile Number'}
                  placeholder={'Mobile Number'}
                  value={props.values['mobilenumber']}
                  type={'number'}
                />
              </div>
              <FormDropdown
                name={'interestedIn'}
                placeholder={"I'm interested in"}
                options={interested_options}
                value={props.values['interestedIn']}
                showPlaceholder={true}
              />
              {/*{!isMobile && (*/}
              <FormTextArea
                name={'remarks'}
                label={'Message'}
                placeholder={'Message'}
                value={props.values['remarks']}
              />
              {/*)}*/}
              <FormButton
                disabled={props.isSubmitting}
                mode={buttonMode}
                onClick={() => this.setState({ isSubmitted: true })}
              />
            </Form>
          )}
        </Formik>
      </div>
    );
  };

  getValidation = () => {
    return Yup.string()
      .trim()
      .required('Please select an option');
  };

  // TODO: Common component for toast?
  onSubmit = (values: FormikValues, actions: FormikHelpers<FormikValues>) => {
    const trimmedValues = this.trimValues(values);
    const errors = this.getErrors(trimmedValues);
    const { callPostLeadAPI, origin, contactEmail: salesEmail } = this.props;
    const pageUrl = `${window.location.origin}${window.location.pathname}`;
    const {
      UTMSource,
      UTMMedium,
      UTMCampaign,
      UTMDisplay,
      UTMTerm,
      UTMContent,
      CampaignCode,
      ProjectInterested,
    } = this.props.utmParameters;
    const reference_no = this.props.referenceNumber;
    const rental_name = this.props.rentalName;
    const is_rental = !!this.props.isRental;
    if (errors.length > 0) {
      // TODO: show errors
      alert(errors);
      return;
    }

    this.state.isSubmitted && actions.setSubmitting(true);
    const { hide: hideLoader } = cogoToast.loading(
      'Submitting your information...',
      {
        hideAfter: 0,
      }
    );

    getGclid('contactUs');
    const contactGclidField = document.getElementById('contactUs_gclid_field')
    const payload = {
      ...trimmedValues,
      UTMSource,
      UTMMedium,
      UTMCampaign,
      UTMDisplay,
      UTMTerm,
      UTMContent,
      ProjectInterested,
      CampaignCode,
      reference_no,
      rental_name,
      is_rental,
    };
    payload.salesEmail = salesEmail;
    payload.isSalesForce = true;
    payload.Gclid = contactGclidField.value;
    if (!callPostLeadAPI) {
      payload.link = pageUrl;
      payload.isSalesForce = false;
    }
    api
      .post(API_ENDPOINT, payload)
      .then(res => {
        if (res.data.status === 'success') {
          hideLoader();
          setTimeout(() => {
            cogoToast.success('Submitted your information successfully!');
          }, 1000);
          window.location.href = '/thank-you';
          actions.resetForm({ ...this.getInitialState() });
        } else {
          hideLoader();
          setTimeout(() => {
            cogoToast.error(res.data.message);
          }, 1000);
        }
      })
      .catch(error => {
        hideLoader();
        setTimeout(() => {
          cogoToast.error('Failed to submit your information');
        }, 1000);
      })
      .finally(() => {
        this.setState({ isSubmitted: false });
        actions.setSubmitting(false);
      });
  };

  trimValues = (values: FormState): FormState => {
    const trimmed = Object.keys(values).reduce((trimmed, key) => {
      if (!trimmed[key]) {
        delete trimmed.country;
        trimmed[key] = values[key].toString().trim();
      }
      trimmed.remarks = trimmed.interestedIn
        ? `${trimmed.interestedIn}\n${trimmed.remarks}`
        : trimmed.remarks;
      delete trimmed.interestedIn;
      return trimmed;
    }, {});

    delete trimmed.contactUs_gclid_field;

    return trimmed;
  };

  getErrors = (
    values: FormState
  ): Array<{ field: string, message: string }> => {
    const errors = [];
    if (!values['lastname'] || values['lastname'] === '') {
      errors.push({
        field: 'lastname',
        message: this.props.isMobile
          ? 'Please enter your First name'
          : 'Please enter your Last name',
      });
    }

    // For sales force api  Only mobile number is mandatory
    if (!values['mobilenumber'] || values['mobilenumber'] === '') {
      errors.push({
        field: 'emailaddress',
        message: 'Please enter your Email address or Phone number',
      });
    }
    return errors;
  };

  checkCountrySelected = () => {
    switch (this.state.selectedCountryName) {
      case 'IND':
      case 'U.S':
        return StringUtil.regexPatterns.phoneINDUS;
      case 'OM':
      case 'SG':
        return StringUtil.regexPatterns.phoneOMSG;
      case 'U.K':
        return StringUtil.regexPatterns.phoneUK;
      case 'AUS':
        return StringUtil.regexPatterns.phoneAUS;
      default:
        return StringUtil.regexPatterns.phone;
    }
  };

  getSchema = () => {
    const schema = {
      subject: Yup.string()
        .trim()
        .required('Please select an option'),
      firstname: Yup.string().trim(),
      lastname: Yup.string()
        .trim()
        .required('Please enter your Last name'),
      emailaddress: Yup.string()
        .trim()
        .email('Please enter a valid email')
        .required('Please enter your email'),
      mobilenumber: Yup.string()
        .trim()
        .required(
          this.props.isMobile
            ? 'Enter phone number'
            : 'Please enter your phone number'
        )
        .matches(
          this.checkCountrySelected(),
          this.props.isMobile
            ? 'invalid phone number'
            : 'enter valid phone number'
        ),

      DialingCode: Yup.string()
        .trim()
        .required('CODE')
        .matches(/^(\+?\d{1,4}|\d{1,4})$/, 'CODE'),
      remarks: Yup.string().trim(),
      interestedIn: this.state.isSubmitted
        ? this.getValidation()
        : Yup.string().trim(),
    };
    return Yup.object().shape(schema, [['mobilenumber', 'emailaddress']]);
  };
}
